/* eslint-disable react-hooks/exhaustive-deps */
import styled from '@emotion/styled';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material';
import { LoginStatusBar } from 'components/LoginStatusBar';
import { RouteStepper, Step } from 'components/RouteStepper';
import { UserAuthContext } from 'contexts/UserAuthContext';
import { TestroomModel } from 'pages/testroom/models/TestroomModel';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ClassOverallResultPath, GradingPath, OverallResultPath, ResultPath, SelectClassPath, SelectQuestionPath, SelectStudentPath, SelectTestroomPath } from 'routes/utils';
import { ClassModel } from '../../models/class/ClassModel';
import { ResultPageProp } from './component/ResultPageTab/ResultPageTab';
import ResultPageTabs from './component/ResultPageTab/ResultPageTabs';
import { Results, StudentProfileWithResults } from './models';

export const ResultsPage = () => {
    const { userData, selectedSchool } = useContext(UserAuthContext);
    const { classId, testroomId, questionIndex, mode } = useParams();
    const navigator = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const [selectedTestRoom, setSelectedTestRoom] = useState<Partial<TestroomModel>>();
    const [selectedClass, setSelectedClass] = useState<ClassModel>();
    const [selectedStudent, setSelectedStudent] = useState<StudentProfileWithResults>();
    const [studentResults, setStudentResults] = useState<Results[]>();
    const [studentsResults, setStudentsResults] = useState<Results[]>();
    const [studentGrading, setStudentGrading] = useState('');
    const [selectedQuestion, setSelectedQuestion] = useState<any>();
    // const [isHomeworkMode, setIsHomeworkMode] = useState<boolean>(false);
    const [gradedItems, setGradedItems] = useState<any>([]);
    const defaultStepperData = useMemo(
        () => [
            {
                text: t('menu-classes'),
                href: `${SelectClassPath}/${selectedSchool?.id}`,
            },
            {
                text: mode === 'Homework' ? t('resultPage.homework') : t('testroom'),
                href: `${SelectClassPath}/${selectedSchool?.id}/${SelectTestroomPath}/${selectedClass?.id}/${mode === 'Homework' ? 'Homework' : 'Classroom'}`,
            },
            {
                text: t('menu-students'),
                href: `${SelectClassPath}/${selectedSchool?.id}/${SelectTestroomPath}/${selectedClass?.id}/${mode === 'Homework' ? 'Homework' : 'Classroom'}/${SelectStudentPath}/${
                    selectedTestRoom?.id
                }`,
            },
            {
                text: t('question'),
                href: `${SelectClassPath}/${selectedSchool?.id}/${SelectTestroomPath}/${selectedClass?.id}/${mode === 'Homework' ? 'Homework' : 'Classroom'}/${
                    mode === 'Homework' ? 'Homework' : 'Classroom'
                }/${SelectStudentPath}/${selectedTestRoom?.id}/${SelectQuestionPath}/${selectedStudent?.id}`,
            },
            {
                text: t('answer'),
                href: `${SelectClassPath}/${selectedSchool?.id}/${SelectTestroomPath}/${selectedClass?.id}/${mode === 'Homework' ? 'Homework' : 'Classroom'}/${SelectStudentPath}/${
                    selectedTestRoom?.id
                }/${SelectQuestionPath}/${selectedStudent?.id}/${GradingPath}/${questionIndex}`,
            },
        ],
        [selectedSchool, selectedClass, selectedTestRoom, selectedStudent, selectedQuestion],
    );
    const [stepper, setStepper] = useState<Step[]>(defaultStepperData.slice(0, 1));
    const [open, setOpen] = useState(false);
    const resultPageTabProp: ResultPageProp[] = [
        {
            label: t('resultPage.overview'),
            navigate: () => {
                navigator(
                    `../${ResultPath}/${SelectClassPath}/${selectedSchool?.id}/${SelectTestroomPath}/${classId}/${mode === 'Homework' ? 'Homework' : 'Classroom'}/${OverallResultPath}/${testroomId}`,
                );
            },
        },
        {
            label: t('resultPage.student'),
            navigate: () => {
                navigator(
                    `../${ResultPath}/${SelectClassPath}/${selectedSchool?.id}/${SelectTestroomPath}/${classId}/${mode === 'Homework' ? 'Homework' : 'Classroom'}/${SelectStudentPath}/${testroomId}`,
                );
            },
        },
        {
            label: t('resultPage.question'),
            navigate: () => {
                navigator(
                    `../${ResultPath}/${SelectClassPath}/${selectedSchool?.id}/${SelectTestroomPath}/${classId}/${mode === 'Homework' ? 'Homework' : 'Classroom'}/${SelectQuestionPath}/${testroomId}`,
                );
            },
        },
    ];

    // const { data: classData, loading: classLoading } = useQuery<ClassQueryModel>(GET_CLASS, {
    //     fetchPolicy: 'no-cache',
    //     notifyOnNetworkStatusChange: true,
    //     variables: {
    //         classId: classId,
    //     },
    //     skip: !userData || !!selectedClass || !classId,
    // });

    // useEffect(() => {
    //     if (classId && classData) {
    //         setSelectedClass(classData.class);
    //     }
    // }, [classData]);

    useEffect(() => {
        if (selectedSchool) {
            const path = location.pathname.includes(SelectTestroomPath) ? location : `${SelectClassPath}/${selectedSchool?.id}`;
            navigator(path);
        }
    }, [selectedSchool]);

    const prepareClassesPage = () => {
        setStepper(defaultStepperData.slice(0, 1));
    };

    const prepareTestroomPage = () => {
        setStepper(defaultStepperData.slice(0, 2));
    };

    const prepareStudentPage = () => {
        setStepper(defaultStepperData.slice(0, 3));
    };

    const prepareQuestionPage = () => {
        setStepper(defaultStepperData.slice(0, 4));
    };
    const prepareGradingPage = () => {
        setStepper(defaultStepperData.slice(0, 5));
    };

    useEffect(() => {
        if (location.pathname.includes(GradingPath)) {
            prepareGradingPage();
        } else if (location.pathname.includes(SelectQuestionPath)) {
            prepareQuestionPage();
        } else if (location.pathname.includes(SelectStudentPath)) {
            prepareStudentPage();
        } else if (location.pathname.includes(SelectTestroomPath)) {
            prepareTestroomPage();
        } else if (location.pathname.includes(SelectClassPath)) {
            prepareClassesPage();
        }
    }, [location, selectedClass, selectedTestRoom, selectedStudent, selectedQuestion]);

    const handleClose = () => {
        setOpen(false);
    };

    const dialog = (
        <Dialog open={open} onClose={handleClose}>
            <DialogContent>
                <DialogContentText sx={{ fontSize: '24px' }}>Grading Saved!</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        handleClose();
                        navigator(SelectStudentPath);
                    }}>
                    Back to Student Screen
                </Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <Container>
            <HeaderContainer>
                <RouteStepper step={stepper} />
                {!location.pathname.includes(SelectStudentPath) && (
                    <ResultTitleContainer>
                        <ResultTitle>{t('menu-results')}</ResultTitle>
                        {userData && <LoginStatusBar user={userData} />}
                    </ResultTitleContainer>
                )}

                <Box
                    sx={{
                        display: 'flex',
                        minHeight: '76px',
                        alignItems: 'center',
                        gap: '64px',
                        flex: '1 0 0',
                        flexDirection: 'row',
                    }}>
                    <Typography fontSize='16px'>
                        {t('resultPage.school')}：{selectedSchool?.schoolName ?? '--'}
                    </Typography>
                    <Typography fontSize='16px'>
                        {t('resultPage.class')}：{selectedClass?.className ?? '--'}
                    </Typography>
                    {/* {location.pathname.includes(OverallResultPath) && !location.pathname.includes(ClassOverallResultPath) && <TestRoomSelector testRooms={testRoomsData} />} */}
                </Box>
                {!location.pathname.includes(ClassOverallResultPath) &&
                    (location.pathname.includes(SelectStudentPath) || location.pathname.includes(OverallResultPath) || location.pathname.includes(SelectQuestionPath)) && (
                        <ResultPageTabs resultTabsProp={resultPageTabProp} />
                    )}
            </HeaderContainer>
            <ResultTableContainer>
                <Outlet
                    context={{
                        userData: userData,
                        selectedSchool: selectedSchool,
                        selectedClass,
                        setSelectedClass,
                        selectedTestRoom,
                        setSelectedTestRoom,
                        studentResults,
                        setStudentResults,
                        studentsResults,
                        setStudentsResults,
                        selectedStudent,
                        setSelectedStudent,
                        selectedQuestion,
                        setSelectedQuestion,
                        studentGrading,
                        setStudentGrading,
                        gradedItems,
                        setGradedItems,
                    }}
                />
            </ResultTableContainer>
            {dialog}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0px 0px 48px 0px;
`;

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 8px;
    background: white;
`;

const ResultTitleContainer = styled.div`
    padding-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

const ResultTableContainer = styled.div`
    padding: 16px;
`;

const ResultTitle = styled.span`
    font-weight: 500;
    font-size: 30px;
    line-height: 150%;
`;
